function addEventListenerToSearchPopup() {
	const filterIcons = document.getElementById('filter-icons');
	if (filterIcons !== null) {
		document.querySelectorAll('.filter-icon').forEach(el => el.addEventListener('click', ev => {

			activateForm(ev.currentTarget);
			changeMainInputName(ev.currentTarget);

		}));
	}

}

export default function elementorInit() {
    //Evento Elementor chiamato all'apertura del popup
    jQuery(document).on('elementor/popup/show', (ev, id) => {
        if (57120 === id) { //Popup di ricerca
            addEventListenerToSearchPopup();
        }
    })

    //Evento Elementor chiamato al submit del form di contatto
    jQuery(document).on('submit_success', (ev) => {
        const form = document.querySelector('.elementor-form-fields-wrapper');
        form.style.display = 'none';
        console.log(ev)
    })

}